import { Panel } from "@poseidon/ui/components/Panel";
import LinearProgress from "@mui/material/LinearProgress";
import ErrorBoundary from "@poseidon/ui/components/ErrorBoundary";
import { CheckListTable } from "@poseidon/ui/components/CheckListTable";
import {
  SailorCheckListItemIdVerified,
  SailorCheckListItemIdvUnblocked,
  SailorCheckListItemIncomeDetails,
  SailorCheckListItemKycAmlCheckDone,
  SailorCheckListItemKycAmlConsent,
  SailorCheckListItemKycAmlDesignation,
  SailorCheckListItemOpenBankingConsent,
  SailorCheckListItemPersonalDetails,
  SailorCheckListItemSupportingDocumentation,
} from "./SailorCheckListItems";
import { useSailorCheckList } from "../hooks/useSailorCheckList";

const deps = {
  kycAml: ["personalDetails", "kycAmlConsent", "kycAmlDesignation"],
  idv: ["personalDetails", "kycAmlCheckDone", "idvUnblocked"],
  openBanking: ["personalDetails", "openBankingConsent"],
  creditCheck: ["personalDetails"],
};

function CheckListTableWired({ sailor, data, applicationId, target }) {
  const sailorId = sailor.id;
  const targetDeps = target ? deps[target] : undefined;
  return (
    <CheckListTable>
      {(!targetDeps || targetDeps.includes("personalDetails")) && (
        <SailorCheckListItemPersonalDetails
          status={data.personalDetails}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("incomeDetails")) && (
        <SailorCheckListItemIncomeDetails
          status={data.incomeDetails}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("kycAmlConsent")) && (
        <SailorCheckListItemKycAmlConsent
          status={data.kycAmlConsent}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("kycAmlDesignation")) && (
        <SailorCheckListItemKycAmlDesignation
          status={data.kycAmlDesignation}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("kycAmlCheckDone")) && (
        <SailorCheckListItemKycAmlCheckDone
          status={data.kycAmlCheckDone}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("idvUnblocked")) && (
        <SailorCheckListItemIdvUnblocked
          status={data.idvUnblocked}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("idVerified")) && (
        <SailorCheckListItemIdVerified
          status={data.idVerified}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
      {(!targetDeps || targetDeps.includes("openBankingConsent")) && (
        <SailorCheckListItemOpenBankingConsent
          status={data.openBankingConsent}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}

      {(!targetDeps || targetDeps.includes("supportingDocumentation")) && (
        <SailorCheckListItemSupportingDocumentation
          status={data.supportingDocumentation}
          sailorId={sailorId}
          applicationId={applicationId}
        />
      )}
    </CheckListTable>
  );
}

export const SailorCheckList = ({ title, sailor, applicationId, target }) => {
  const { loading, checklist: data } = useSailorCheckList(sailor);
  return (
    <Panel title={title ?? "Check List"} expandable>
      {loading ? (
        <LinearProgress />
      ) : (
        <ErrorBoundary>
          <CheckListTableWired
            data={data}
            sailor={sailor}
            applicationId={applicationId}
            target={target}
          />
        </ErrorBoundary>
      )}
    </Panel>
  );
};
